// Gate authenticated routes. While hydrating shows a spinner; after hydration,
// unauthenticated visitors get redirected to /login.

import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { ROUTES } from '../../config/routes';
import { useAuth } from './useAuth';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, isHydrated } = useAuth();

  if (!isHydrated) {
    return (
      <div style={{ height: '100vh', display: 'grid', placeItems: 'center' }}>
        <Spin size="large" />
      </div>
    );
  }
  if (!isAuthenticated) {
    return <Navigate to={ROUTES.login} replace />;
  }
  return <>{children}</>;
}
